import { LLMProvider } from './base';
import { supabase } from '../lib/supabase';

export class SystemProvider extends LLMProvider {
  constructor(config = {}) {
    super(null, { model: 'claude-haiku-4-5-20251001', ...config });
  }

  getModelName() { return 'LEARNATLAS AI (Claude Haiku)'; }

  validateApiKey() { return true; }

  async _invoke(messages, systemPrompt) {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session?.access_token) throw new Error('Utente non autenticato');

    const { data, error } = await supabase.functions.invoke('llm-proxy', {
      body: { messages, systemPrompt },
    });

    if (error) {
      let body = null;
      try { body = await error.context?.clone().json(); } catch { /* noop */ }
      if (body?.error === 'DAILY_CAP_EXCEEDED') throw new Error('DAILY_CAP_EXCEEDED');
      throw new Error(body ? JSON.stringify(body) : error.message);
    }

    if (data?.error === 'DAILY_CAP_EXCEEDED') throw new Error('DAILY_CAP_EXCEEDED');
    return data.content;
  }

  async chat(userMessage, systemPrompt = '') {
    const messages = [{ role: 'user', content: userMessage }];
    return this._invoke(messages, systemPrompt);
  }

  async chatMultiTurn(messages, systemPrompt = '') {
    return this._invoke(messages, systemPrompt);
  }
}
